const SubscriptionKeys = {
    TITLE: "title",
    SUBSCRIPTION_CODE: "subscriptionCode",
    SUBSCRIPTION_NAME: "subscriptionName",
    SUBSCRIPTION_DESCRIPTION: "subscriptionDescription",
    STATUS: "status"
}

export default SubscriptionKeys
